import { IRootState } from "redux/reducer";
import { DictionaryKind } from "./types";

export const getLastLoadTimestamp = (
  state: IRootState,
  key: DictionaryKind
) => {
  return state.dictionaries.loadedTimestamp[key];
};
